import { api } from "./api";

/**
 * Native Sign in with Apple: presents the system Face ID sheet via the
 * Capacitor plugin, then exchanges Apple's identity token for a caloly
 * session. Only callable inside the iOS app (isNativeApp()).
 */
export async function nativeAppleSignIn(locale: "en" | "de"): Promise<void> {
  const { SignInWithApple } = await import("@capacitor-community/apple-sign-in");
  const result = await SignInWithApple.authorize({
    clientId: "com.caloly.app",
    redirectURI: "https://caloly.com",
    scopes: "email name",
  });
  const token = result.response.identityToken;
  if (!token) throw new Error("no identity token");
  const name = [result.response.givenName, result.response.familyName].filter(Boolean).join(" ");
  await api.nativeAppleLogin(token, name || undefined, locale);
}
